// lodash
import isString from 'lodash/isString';

export default function stripWhitespace(string = '') {
  if (!isString(string)) {
    return string;
  }
  return string.replace(/[\n\r\s]/g, '');
}
